import { useRef } from "react";
import { motion, useScroll, useTransform, useReducedMotion } from "framer-motion";

export default function Watermark({ text = "SMART LEGAL SOLUTIONS", mobileText = "SLS", dark = false, className = "" }) {
  const ref = useRef(null);
  const reduce = useReducedMotion();
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-8%", "8%"]);
  const style = reduce ? {} : { y };
  return (
    <div ref={ref} aria-hidden="true" className={`pointer-events-none absolute inset-0 overflow-hidden ${className}`}>
      <motion.div style={style} className="absolute inset-0 flex items-center justify-center">
        <span className={`${dark ? "watermark-text-dark" : "watermark-text"} hidden text-[22vw] md:block`}>{text}</span>
        <span className={`${dark ? "watermark-text-dark" : "watermark-text"} block text-[58vw] md:hidden`}>{mobileText}</span>
      </motion.div>
    </div>
  );
}
